import { FriendlyError, ResponsiveDialog } from '@cibo/ui'
import { LoadingButton } from '@mui/lab'
import { Button, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { GridRowId } from '@mui/x-data-grid-pro'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useMergeLabels } from '../queries'
import { LabelEditorField } from './Editors'

export type AddLabelsModalProps = {
  onRequestClose(): void
  target?: GridRowId[]
  visible: boolean
}

export const AddLabelsModal = ({ onRequestClose, target, visible }: AddLabelsModalProps) => {
  const { t } = useTranslation('@cibo/landmanager/components/Editors/LabelEditor')
  const mergeLabels = useMergeLabels()

  const [labels, setLabels] = useState<string[]>()
  const [error, setError] = useState<Error | undefined>()

  const onSave = () => {
    mergeLabels.mutateAsync(
      {
        resourceIds: target as string[],
        labels: labels || [],
      },
      {
        onSuccess: () => {
          setError(undefined)
          onRequestClose()
        },
        onError: error => setError(error as Error),
      }
    )
  }

  return (
    <ResponsiveDialog open={visible} onClose={onRequestClose} fullWidth maxWidth="sm">
      <DialogTitle>{t('Add Labels')}</DialogTitle>
      <DialogContent>
        <LabelEditorField disabled={mergeLabels.isLoading} onChange={setLabels} />

        {/* Of note: the below error cannot be reasonably translated, because it contains the string value of the label which is erroring */}
        {/* @ts-ignore error is not appropriately typed */}
        {!!error && <FriendlyError message={error.response.data.message} />}
      </DialogContent>
      <DialogActions>
        <Button onClick={onRequestClose}>{t('cancel')}</Button>
        <LoadingButton
          loading={mergeLabels.isLoading}
          variant="contained"
          onClick={onSave}
          disabled={!labels}
        >
          {t('save')}
        </LoadingButton>
      </DialogActions>
    </ResponsiveDialog>
  )
}
